(ns app.domain.payment.provider.model
  (:require [cloudpermit-commons.schemas.general :as general]
            [schema.core :as s]))


(s/defschema E-xactConfig
  {:transaction-key general/NonBlankString
   :response-key    general/NonBlankString
   :x_login         general/NonBlankString
   :url             general/NonBlankString})


(s/defschema MonerisConfig
  {:ps_store_id general/NonBlankString
   :hpp_key     general/NonBlankString
   :moneris-url general/NonBlankString})


(s/defschema MonerisCheckoutConfig
  {:store_id    general/NonBlankString
   :api_token   general/NonBlankString
   :checkout_id general/NonBlankString
   :moneris_url general/NonBlankString})


(s/defschema BamboraConfig
  {:merchant_id general/NonBlankString
   :hash_key    general/NonBlankString})


(s/defschema AllpaidConfig
  {:plc_id            general/NonBlankString
   :hash_key          general/NonBlankString
   :payee_first_name  general/NonBlankString
   :payee_middle_name general/NonBlankString
   :payee_last_name   general/NonBlankString
   :post_url          general/NonBlankString})


(s/defschema EpayConfig
  {:client_key     general/NonBlankString
   :web_key        general/NonBlankString
   :payment_type   s/Int ; 1 = "Absorbing Permit", 2 = "Passing Permit"
   :payment_method (s/enum 0 1 2 3) ; 0 = Block(eCheck and Credit Card), 1 = Accept(eChecks Only),
   ; 2 = Accept(Credit Cards Only), 3 = Accept(eCheck and Credit Card)
   :base_url       general/NonBlankString})


(s/defschema PaymentusConfig
  {:encryption-key                         general/NonBlankString
   :url                                    general/NonBlankString
   :payment-type-code                      general/NonBlankString
   (s/optional-key :use-municipal-case-id) s/Bool})


(s/defschema CCP-NICConfig
  {:url           general/NonBlankString
   :merchant-code general/NonBlankString
   :merchant-key  general/NonBlankString
   :service-code  general/NonBlankString
   :api-key       general/NonBlankString})


(s/defschema GovernmentWindowConfig
  {:url        general/NonBlankString
   :secret-key general/NonBlankString})


(s/defschema MerchanteConfig
  {:url               general/NonBlankString
   :merchant-id       general/NonBlankString
   :response-username general/NonBlankString
   :response-password general/NonBlankString})


(s/defschema SquareConfig
  {:url          general/NonBlankString
   :location-id  general/NonBlankString
   :access-token general/NonBlankString})


(s/defschema StripeConfig
  {:api-key        general/NonBlankString
   :webhook-secret general/NonBlankString})


(s/defschema PayNowLinkConfig
  {:user_id  general/NonBlankString
   :password general/NonBlankString
   :item_key general/NonBlankString})


(s/defschema CardType (s/enum :card-type/visa
                              :card-type/mastercard
                              :card-type/discover
                              :card-type/amex))


(s/defschema GlobalPaymentsTXUI
  {:xweb-id             general/NonBlankString
   :terminal-id         general/NonBlankString
   :auth-key            general/NonBlankString
   :accepted-card-types #{CardType}})


(s/defschema MsbConfig
  {:url        general/NonBlankString
   :secret-key general/NonBlankString})


(s/defschema PointPayConfig
  {:url        general/NonBlankString
   :product-id general/NonBlankString})


(s/defschema ElavonConfig
  {:ssl_merchant_id general/NonBlankString
   :ssl_user_id     general/NonBlankString
   :ssl_pin         general/NonBlankString})


(s/defschema AciConfig
  {:url        general/NonBlankString
   :product-id general/NonBlankString})


(s/defschema XpressBillPayConfig
  {:url                              general/NonBlankString
   :application_id                   general/NonBlankString
   :application_key                  general/NonBlankString
   (s/optional-key :item_id)         s/Str
   (s/optional-key :item_id_default) s/Str})


(s/defschema CloverConfig
  {:merchant-id            general/NonBlankString
   :private-token          general/NonBlankString
   :webhook-signing-secret general/NonBlankString})


(s/defschema InvoiceCloudConfig
  {:api-key     general/NonBlankString
   :biller-guid general/NonBlankString
   :type-id     (s/enum 1 2 3 6 42 43 57 88 94)})


(s/defschema AuthorizeNetConfig
  {:api-login-id    general/NonBlankString
   :transaction-key general/NonBlankString
   :signature-key   general/NonBlankString})


(s/defschema PSNOnlineConfig
  {:account-id general/NonBlankString})


(s/defschema PayPalConfig
  {:client-id     general/NonBlankString
   :client-secret general/NonBlankString})

(s/defschema ForteConfig
  {:access-id   general/NonBlankString
   :secure-key  general/NonBlankString
   :location-id general/NonBlankString})

(s/defschema PayGovUSConfig
  {:ttid         general/NonBlankString
   :api-password general/NonBlankString})

(s/defschema MuniciPayConfig
  {:api-url     general/NonBlankString
   :api-slug    general/NonBlankString
   :api-key     general/NonBlankString
   :item-number general/NonBlankString
   :item-type   general/NonBlankString})

(s/defschema HeartLandConfig
  {:public-key general/NonBlankString
   :secret-key general/NonBlankString})

(s/defschema UnipayConfig
  {:access-key     general/NonBlankString
   :customer-id    general/NonBlankString
   :transaction-id general/NonBlankString
   :url            general/NonBlankString})

(s/defschema GovtPortalConfig
  {:portal-id  general/NonBlankString
   :secret-key general/NonBlankString
   :url        general/NonBlankString
   :verify-url general/NonBlankString})

(def provider->schema
  {:payment-service/e-xact                E-xactConfig
   :payment-service/moneris               MonerisConfig
   :payment-service/moneris-co            MonerisCheckoutConfig
   :payment-service/bambora               BamboraConfig
   :payment-service/allpaid               AllpaidConfig
   :payment-service/epay                  EpayConfig
   :payment-service/paymentus             PaymentusConfig
   :payment-service/ccp-nic               CCP-NICConfig
   :payment-service/government-window     GovernmentWindowConfig
   :payment-service/merchante             MerchanteConfig
   :payment-service/square                SquareConfig
   :payment-service/stripe                StripeConfig
   ;; These two providers are functionally the same thing.
   :payment-service/payeezy               E-xactConfig
   :payment-service/paynowlink            PayNowLinkConfig
   :payment-service/global-payments-tx-ui GlobalPaymentsTXUI
   :payment-service/msb                   MsbConfig
   :payment-service/point-pay             PointPayConfig
   :payment-service/elavon                ElavonConfig
   :payment-service/aci                   AciConfig
   :payment-service/xpress-bill-pay       XpressBillPayConfig
   :payment-service/clover                CloverConfig
   :payment-service/icop                  InvoiceCloudConfig
   :payment-service/authorize-net         AuthorizeNetConfig
   :payment-service/psn                   PSNOnlineConfig
   :payment-service/paypal                PayPalConfig
   :payment-service/forte                 ForteConfig
   :payment-service/paygov-us             PayGovUSConfig
   :payment-service/municipay             MuniciPayConfig
   :payment-service/heartland             HeartLandConfig
   :payment-service/unipay                UnipayConfig
   :payment-service/govt-portal           GovtPortalConfig
   #__})



(def provider->help-text
  {:payment-service/epay      {:payment_type   "1 = \"Absorbing Permit\", 2 = \"Passing Permit\""
                               :payment_method {0 "0: Block (eCheck and Credit Card)"
                                                1 "1: Accept (eChecks Only)"
                                                2 "2: Accept (Credit Cards Only)"
                                                3 "3: Accept (eCheck and Credit Card)"}}
   :payment-service/bambora   {:payment-method/convenience-fee-percentage :payment.config/bambora-convenience-fee-help}
   :payment-service/paymentus {:use-municipal-case-id :payment.config/integration-warning}
   :payment-service/icop      {:type-id {1  "1 – Water"
                                         2  "2 – Electric"
                                         3  "3 – Sewer"
                                         6  "6 – Government services"
                                         42 "42 – Utility"
                                         43 "43 – Permits"
                                         57 "57 – Business License"
                                         88 "88 – Permits II"
                                         94 "94 – Permits III"}}})

(def provider->card-type
  {:payment-service/e-xact ["VISA"
                            "MASTERCARD"
                            "AMERICAN EXPRESS"
                            "DINERS CLUB"
                            "DISCOVER"
                            "ENROUTE"
                            "JCB"
                            "HAMILTON FINANCIAL"
                            "SEARS"
                            "MAESTRO"
                            "PAYPAL"
                            "Unknown"]
   ;; no list allows string input
   })


(def provider->features
  {:payment-service/bambora #{:convenience-fees}
   :payment-service/stripe  #{:convenience-fees}
   :payment-service/square  #{:convenience-fees}})

(defn convenience-fees-supported? [provider]
  (some-> provider provider->features :convenience-fees))

(def providers-supporting-escrow-deposit
  "Payment providers for which the escrow deposit support has been implemented."
  #{:payment-service/e-xact
    :payment-service/allpaid
    :payment-service/bambora
    :payment-service/psn
    :payment-service/heartland
    :payment-service/unipay
    :payment-service/govt-portal})

(defn escrow-deposit-supported? [provider]
  (contains? providers-supporting-escrow-deposit provider))

(defmulti validate-provider-config
  "Provider-specific validation for payment configurations.
   Returns nil if valid, or an error map if invalid.
   Default implementation returns nil (no validation)."
  (fn [provider _config] provider))

(defmethod validate-provider-config :default
  [_ _]
  nil)
